import { createTheme } from "@mui/material/styles";

// Thème de base partagé par toute l'application. Les écrans qui ont besoin de
// surcharges spécifiques (DataGrid) le dérivent via createTheme(baseTheme, ...)
// afin d'en hériter la palette et la typographie.
const baseTheme = createTheme({
  palette: {
    primary: {
      main: "#3f51b5",
      dark: "#2c387e",
    },
    secondary: {
      main: "#dc004e",
    },
    // Rouge de la charte, utilisé pour la déconnexion et les messages d'erreur.
    error: {
      main: "#b3070f",
    },
    background: {
      default: "#f5f6fa",
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    // Aucune police web n'est chargée : on s'appuie sur la pile système.
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: { fontSize: "2rem", fontWeight: 500 },
    h4: { fontSize: "1.75rem", fontWeight: 600 },
    h5: { fontSize: "1.375rem", fontWeight: 500 },
    h6: { fontSize: "1.125rem", fontWeight: 500 },
    button: { textTransform: "none", fontWeight: 500 },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        asterisk: ({ theme }) => ({ color: theme.palette.error.main }),
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: { borderRadius: 12 },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
    MuiTextField: {
      defaultProps: { size: "small" },
    },
    // Habillage commun aux trois tableaux. La classe "app-theme" est posée en
    // headerClassName sur chaque colonne.
    MuiDataGrid: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 12,
          "& .app-theme": {
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.text.primary,
            fontWeight: 600,
          },
          "& .MuiDataGrid-columnSeparator": { color: theme.palette.divider },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
        }),
      },
    },
  },
});

export default baseTheme;
